export default (varName, value, options) => {
    options.data[varName] = value;
    return '';
};
